/**
 * Generated by orval v7.17.0 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import { useMutation, useQuery } from '@tanstack/react-query'
import type {
    DataTag,
    DefinedInitialDataOptions,
    DefinedUseQueryResult,
    MutationFunction,
    QueryClient,
    QueryFunction,
    QueryKey,
    UndefinedInitialDataOptions,
    UseMutationOptions,
    UseMutationResult,
    UseQueryOptions,
    UseQueryResult,
} from '@tanstack/react-query'

import type {
    GetRequestShouldSendUserStatisticsEventsParams,
    HTTPValidationErrorDTO,
    PostCumulusEventsResponseDTO,
    PostRequestClientStatsBodies,
    PostRequestClientStatsParams,
    PostRequestDebugEventsParams,
    PostRequestRunTimeStatisticsParams,
    PostRequestUserStatisticsEventsBodies,
    PostRequestUserStatisticsEventsParams,
    PostRequestWebClientStatsParams,
    RunTimeStatsModelDTO,
    ShouldSendUserStatsEventsResponseDTO,
    WebClientStatsDTO,
} from '../../model'

import { customInstance } from '../../../customInstance'
import type { ErrorType, BodyType } from '../../../customInstance'

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1]

/**
 * @summary Post Web Client Stats
 */
export const postRequestWebClientStats = (
    webClientStatsDTO: BodyType<WebClientStatsDTO>,
    params: PostRequestWebClientStatsParams,
    options?: SecondParameter<typeof customInstance>,
    signal?: AbortSignal,
) => {
    return customInstance<unknown>(
        {
            url: `/web_client_stats`,
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            data: webClientStatsDTO,
            params,
            signal,
        },
        options,
    )
}

export const getPostRequestWebClientStatsMutationOptions = <
    TError = ErrorType<HTTPValidationErrorDTO>,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof postRequestWebClientStats>>,
        TError,
        {
            data: BodyType<WebClientStatsDTO>
            params: PostRequestWebClientStatsParams
        },
        TContext
    >
    request?: SecondParameter<typeof customInstance>
}): UseMutationOptions<
    Awaited<ReturnType<typeof postRequestWebClientStats>>,
    TError,
    {
        data: BodyType<WebClientStatsDTO>
        params: PostRequestWebClientStatsParams
    },
    TContext
> => {
    const mutationKey = ['postRequestWebClientStats']
    const { mutation: mutationOptions, request: requestOptions } = options
        ? options.mutation &&
          'mutationKey' in options.mutation &&
          options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey }, request: undefined }

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof postRequestWebClientStats>>,
        {
            data: BodyType<WebClientStatsDTO>
            params: PostRequestWebClientStatsParams
        }
    > = (props) => {
        const { data, params } = props ?? {}

        return postRequestWebClientStats(data, params, requestOptions)
    }

    return { mutationFn, ...mutationOptions }
}

export type PostRequestWebClientStatsMutationResult = NonNullable<
    Awaited<ReturnType<typeof postRequestWebClientStats>>
>
export type PostRequestWebClientStatsMutationBody = BodyType<WebClientStatsDTO>
export type PostRequestWebClientStatsMutationError =
    ErrorType<HTTPValidationErrorDTO>

/**
 * @summary Post Web Client Stats
 */
export const usePostRequestWebClientStats = <
    TError = ErrorType<HTTPValidationErrorDTO>,
    TContext = unknown,
>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<ReturnType<typeof postRequestWebClientStats>>,
            TError,
            {
                data: BodyType<WebClientStatsDTO>
                params: PostRequestWebClientStatsParams
            },
            TContext
        >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): UseMutationResult<
    Awaited<ReturnType<typeof postRequestWebClientStats>>,
    TError,
    {
        data: BodyType<WebClientStatsDTO>
        params: PostRequestWebClientStatsParams
    },
    TContext
> => {
    const mutationOptions = getPostRequestWebClientStatsMutationOptions(options)

    return useMutation(mutationOptions, queryClient)
}
/**
 * this call updates the client status

 * @summary Client Stats
 */
export const postRequestClientStats = (
    postRequestClientStatsBodies: BodyType<PostRequestClientStatsBodies>,
    params: PostRequestClientStatsParams,
    options?: SecondParameter<typeof customInstance>,
    signal?: AbortSignal,
) => {
    return customInstance<unknown>(
        {
            url: `/client_stats`,
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            data: postRequestClientStatsBodies,
            params,
            signal,
        },
        options,
    )
}

export const getPostRequestClientStatsMutationOptions = <
    TError = ErrorType<void | HTTPValidationErrorDTO>,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof postRequestClientStats>>,
        TError,
        {
            data: BodyType<PostRequestClientStatsBodies>
            params: PostRequestClientStatsParams
        },
        TContext
    >
    request?: SecondParameter<typeof customInstance>
}): UseMutationOptions<
    Awaited<ReturnType<typeof postRequestClientStats>>,
    TError,
    {
        data: BodyType<PostRequestClientStatsBodies>
        params: PostRequestClientStatsParams
    },
    TContext
> => {
    const mutationKey = ['postRequestClientStats']
    const { mutation: mutationOptions, request: requestOptions } = options
        ? options.mutation &&
          'mutationKey' in options.mutation &&
          options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey }, request: undefined }

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof postRequestClientStats>>,
        {
            data: BodyType<PostRequestClientStatsBodies>
            params: PostRequestClientStatsParams
        }
    > = (props) => {
        const { data, params } = props ?? {}

        return postRequestClientStats(data, params, requestOptions)
    }

    return { mutationFn, ...mutationOptions }
}

export type PostRequestClientStatsMutationResult = NonNullable<
    Awaited<ReturnType<typeof postRequestClientStats>>
>
export type PostRequestClientStatsMutationBody =
    BodyType<PostRequestClientStatsBodies>
export type PostRequestClientStatsMutationError =
    ErrorType<void | HTTPValidationErrorDTO>

/**
 * @summary Client Stats
 */
export const usePostRequestClientStats = <
    TError = ErrorType<void | HTTPValidationErrorDTO>,
    TContext = unknown,
>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<ReturnType<typeof postRequestClientStats>>,
            TError,
            {
                data: BodyType<PostRequestClientStatsBodies>
                params: PostRequestClientStatsParams
            },
            TContext
        >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): UseMutationResult<
    Awaited<ReturnType<typeof postRequestClientStats>>,
    TError,
    {
        data: BodyType<PostRequestClientStatsBodies>
        params: PostRequestClientStatsParams
    },
    TContext
> => {
    const mutationOptions = getPostRequestClientStatsMutationOptions(options)

    return useMutation(mutationOptions, queryClient)
}
/**
 * This call adds user statistics events

 * @summary Post User Statistics Events
 */
export const postRequestUserStatisticsEvents = (
    postRequestUserStatisticsEventsBodies: BodyType<PostRequestUserStatisticsEventsBodies>,
    params: PostRequestUserStatisticsEventsParams,
    options?: SecondParameter<typeof customInstance>,
    signal?: AbortSignal,
) => {
    return customInstance<PostCumulusEventsResponseDTO>(
        {
            url: `/user_statistics_events`,
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            data: postRequestUserStatisticsEventsBodies,
            params,
            signal,
        },
        options,
    )
}

export const getPostRequestUserStatisticsEventsMutationOptions = <
    TError = ErrorType<void | HTTPValidationErrorDTO>,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof postRequestUserStatisticsEvents>>,
        TError,
        {
            data: BodyType<PostRequestUserStatisticsEventsBodies>
            params: PostRequestUserStatisticsEventsParams
        },
        TContext
    >
    request?: SecondParameter<typeof customInstance>
}): UseMutationOptions<
    Awaited<ReturnType<typeof postRequestUserStatisticsEvents>>,
    TError,
    {
        data: BodyType<PostRequestUserStatisticsEventsBodies>
        params: PostRequestUserStatisticsEventsParams
    },
    TContext
> => {
    const mutationKey = ['postRequestUserStatisticsEvents']
    const { mutation: mutationOptions, request: requestOptions } = options
        ? options.mutation &&
          'mutationKey' in options.mutation &&
          options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey }, request: undefined }

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof postRequestUserStatisticsEvents>>,
        {
            data: BodyType<PostRequestUserStatisticsEventsBodies>
            params: PostRequestUserStatisticsEventsParams
        }
    > = (props) => {
        const { data, params } = props ?? {}

        return postRequestUserStatisticsEvents(data, params, requestOptions)
    }

    return { mutationFn, ...mutationOptions }
}

export type PostRequestUserStatisticsEventsMutationResult = NonNullable<
    Awaited<ReturnType<typeof postRequestUserStatisticsEvents>>
>
export type PostRequestUserStatisticsEventsMutationBody =
    BodyType<PostRequestUserStatisticsEventsBodies>
export type PostRequestUserStatisticsEventsMutationError =
    ErrorType<void | HTTPValidationErrorDTO>

/**
 * @summary Post User Statistics Events
 */
export const usePostRequestUserStatisticsEvents = <
    TError = ErrorType<void | HTTPValidationErrorDTO>,
    TContext = unknown,
>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<ReturnType<typeof postRequestUserStatisticsEvents>>,
            TError,
            {
                data: BodyType<PostRequestUserStatisticsEventsBodies>
                params: PostRequestUserStatisticsEventsParams
            },
            TContext
        >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): UseMutationResult<
    Awaited<ReturnType<typeof postRequestUserStatisticsEvents>>,
    TError,
    {
        data: BodyType<PostRequestUserStatisticsEventsBodies>
        params: PostRequestUserStatisticsEventsParams
    },
    TContext
> => {
    const mutationOptions =
        getPostRequestUserStatisticsEventsMutationOptions(options)

    return useMutation(mutationOptions, queryClient)
}
/**
 * @summary Post Debug Events
 */
export const postRequestDebugEvents = (
    params: PostRequestDebugEventsParams,
    options?: SecondParameter<typeof customInstance>,
    signal?: AbortSignal,
) => {
    return customInstance<PostCumulusEventsResponseDTO>(
        { url: `/debug_events`, method: 'POST', params, signal },
        options,
    )
}

export const getPostRequestDebugEventsMutationOptions = <
    TError = ErrorType<HTTPValidationErrorDTO>,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof postRequestDebugEvents>>,
        TError,
        { params: PostRequestDebugEventsParams },
        TContext
    >
    request?: SecondParameter<typeof customInstance>
}): UseMutationOptions<
    Awaited<ReturnType<typeof postRequestDebugEvents>>,
    TError,
    { params: PostRequestDebugEventsParams },
    TContext
> => {
    const mutationKey = ['postRequestDebugEvents']
    const { mutation: mutationOptions, request: requestOptions } = options
        ? options.mutation &&
          'mutationKey' in options.mutation &&
          options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey }, request: undefined }

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof postRequestDebugEvents>>,
        { params: PostRequestDebugEventsParams }
    > = (props) => {
        const { params } = props ?? {}

        return postRequestDebugEvents(params, requestOptions)
    }

    return { mutationFn, ...mutationOptions }
}

export type PostRequestDebugEventsMutationResult = NonNullable<
    Awaited<ReturnType<typeof postRequestDebugEvents>>
>

export type PostRequestDebugEventsMutationError =
    ErrorType<HTTPValidationErrorDTO>

/**
 * @summary Post Debug Events
 */
export const usePostRequestDebugEvents = <
    TError = ErrorType<HTTPValidationErrorDTO>,
    TContext = unknown,
>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<ReturnType<typeof postRequestDebugEvents>>,
            TError,
            { params: PostRequestDebugEventsParams },
            TContext
        >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): UseMutationResult<
    Awaited<ReturnType<typeof postRequestDebugEvents>>,
    TError,
    { params: PostRequestDebugEventsParams },
    TContext
> => {
    const mutationOptions = getPostRequestDebugEventsMutationOptions(options)

    return useMutation(mutationOptions, queryClient)
}
/**
 * Push run-time statistics for the client
- $ref: '#/parameters/captureTokenParam'
- $ref: '#/parameters/app_key_required'
- $ref: '#/parameters/device_id_query_required'
- name: run_time_statitics
  in: body
  description: run-time data
  required: True
  schema:
    type: object
    properties:
      run_time_intervals:
        type: array
        items:
          type: object
          properties:
            start_time:
              type: integer
            end_time:
              type: integer
            start_battery_level:
              type: float
            end_battery_level:
              type: float
            with_ac:
              type: bool
            with_wifi:
              type: bool
            with_background_boost:
              type: bool
              required: False

 * @summary Post Run Time Statistics
 */
export const postRequestRunTimeStatistics = (
    runTimeStatsModelDTO: BodyType<RunTimeStatsModelDTO>,
    params: PostRequestRunTimeStatisticsParams,
    options?: SecondParameter<typeof customInstance>,
    signal?: AbortSignal,
) => {
    return customInstance<unknown>(
        {
            url: `/run_time_statistics`,
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            data: runTimeStatsModelDTO,
            params,
            signal,
        },
        options,
    )
}

export const getPostRequestRunTimeStatisticsMutationOptions = <
    TError = ErrorType<void | HTTPValidationErrorDTO>,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof postRequestRunTimeStatistics>>,
        TError,
        {
            data: BodyType<RunTimeStatsModelDTO>
            params: PostRequestRunTimeStatisticsParams
        },
        TContext
    >
    request?: SecondParameter<typeof customInstance>
}): UseMutationOptions<
    Awaited<ReturnType<typeof postRequestRunTimeStatistics>>,
    TError,
    {
        data: BodyType<RunTimeStatsModelDTO>
        params: PostRequestRunTimeStatisticsParams
    },
    TContext
> => {
    const mutationKey = ['postRequestRunTimeStatistics']
    const { mutation: mutationOptions, request: requestOptions } = options
        ? options.mutation &&
          'mutationKey' in options.mutation &&
          options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey }, request: undefined }

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof postRequestRunTimeStatistics>>,
        {
            data: BodyType<RunTimeStatsModelDTO>
            params: PostRequestRunTimeStatisticsParams
        }
    > = (props) => {
        const { data, params } = props ?? {}

        return postRequestRunTimeStatistics(data, params, requestOptions)
    }

    return { mutationFn, ...mutationOptions }
}

export type PostRequestRunTimeStatisticsMutationResult = NonNullable<
    Awaited<ReturnType<typeof postRequestRunTimeStatistics>>
>
export type PostRequestRunTimeStatisticsMutationBody =
    BodyType<RunTimeStatsModelDTO>
export type PostRequestRunTimeStatisticsMutationError =
    ErrorType<void | HTTPValidationErrorDTO>

/**
 * @summary Post Run Time Statistics
 */
export const usePostRequestRunTimeStatistics = <
    TError = ErrorType<void | HTTPValidationErrorDTO>,
    TContext = unknown,
>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<ReturnType<typeof postRequestRunTimeStatistics>>,
            TError,
            {
                data: BodyType<RunTimeStatsModelDTO>
                params: PostRequestRunTimeStatisticsParams
            },
            TContext
        >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): UseMutationResult<
    Awaited<ReturnType<typeof postRequestRunTimeStatistics>>,
    TError,
    {
        data: BodyType<RunTimeStatsModelDTO>
        params: PostRequestRunTimeStatisticsParams
    },
    TContext
> => {
    const mutationOptions =
        getPostRequestRunTimeStatisticsMutationOptions(options)

    return useMutation(mutationOptions, queryClient)
}
/**
 * Signal if clients should send user statistics

 * @summary Should Send User Statistics Events
 */
export const getRequestShouldSendUserStatisticsEvents = (
    params: GetRequestShouldSendUserStatisticsEventsParams,
    options?: SecondParameter<typeof customInstance>,
    signal?: AbortSignal,
) => {
    return customInstance<ShouldSendUserStatsEventsResponseDTO>(
        {
            url: `/should_send_user_statistics_events`,
            method: 'GET',
            params,
            signal,
        },
        options,
    )
}

export const getGetRequestShouldSendUserStatisticsEventsQueryKey = (
    params?: GetRequestShouldSendUserStatisticsEventsParams,
) => {
    return [
        `/should_send_user_statistics_events`,
        ...(params ? [params] : []),
    ] as const
}

export const getGetRequestShouldSendUserStatisticsEventsQueryOptions = <
    TData = Awaited<
        ReturnType<typeof getRequestShouldSendUserStatisticsEvents>
    >,
    TError = ErrorType<HTTPValidationErrorDTO>,
>(
    params: GetRequestShouldSendUserStatisticsEventsParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<typeof getRequestShouldSendUserStatisticsEvents>
                >,
                TError,
                TData
            >
        >
        request?: SecondParameter<typeof customInstance>
    },
) => {
    const { query: queryOptions, request: requestOptions } = options ?? {}

    const queryKey =
        queryOptions?.queryKey ??
        getGetRequestShouldSendUserStatisticsEventsQueryKey(params)

    const queryFn: QueryFunction<
        Awaited<ReturnType<typeof getRequestShouldSendUserStatisticsEvents>>
    > = ({ signal }) =>
        getRequestShouldSendUserStatisticsEvents(params, requestOptions, signal)

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<typeof getRequestShouldSendUserStatisticsEvents>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetRequestShouldSendUserStatisticsEventsQueryResult = NonNullable<
    Awaited<ReturnType<typeof getRequestShouldSendUserStatisticsEvents>>
>
export type GetRequestShouldSendUserStatisticsEventsQueryError =
    ErrorType<HTTPValidationErrorDTO>

export function useGetRequestShouldSendUserStatisticsEvents<
    TData = Awaited<
        ReturnType<typeof getRequestShouldSendUserStatisticsEvents>
    >,
    TError = ErrorType<HTTPValidationErrorDTO>,
>(
    params: GetRequestShouldSendUserStatisticsEventsParams,
    options: {
        query: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<typeof getRequestShouldSendUserStatisticsEvents>
                >,
                TError,
                TData
            >
        > &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<
                        ReturnType<
                            typeof getRequestShouldSendUserStatisticsEvents
                        >
                    >,
                    TError,
                    Awaited<
                        ReturnType<
                            typeof getRequestShouldSendUserStatisticsEvents
                        >
                    >
                >,
                'initialData'
            >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
}
export function useGetRequestShouldSendUserStatisticsEvents<
    TData = Awaited<
        ReturnType<typeof getRequestShouldSendUserStatisticsEvents>
    >,
    TError = ErrorType<HTTPValidationErrorDTO>,
>(
    params: GetRequestShouldSendUserStatisticsEventsParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<typeof getRequestShouldSendUserStatisticsEvents>
                >,
                TError,
                TData
            >
        > &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<
                        ReturnType<
                            typeof getRequestShouldSendUserStatisticsEvents
                        >
                    >,
                    TError,
                    Awaited<
                        ReturnType<
                            typeof getRequestShouldSendUserStatisticsEvents
                        >
                    >
                >,
                'initialData'
            >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
}
export function useGetRequestShouldSendUserStatisticsEvents<
    TData = Awaited<
        ReturnType<typeof getRequestShouldSendUserStatisticsEvents>
    >,
    TError = ErrorType<HTTPValidationErrorDTO>,
>(
    params: GetRequestShouldSendUserStatisticsEventsParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<typeof getRequestShouldSendUserStatisticsEvents>
                >,
                TError,
                TData
            >
        >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
}
/**
 * @summary Should Send User Statistics Events
 */

export function useGetRequestShouldSendUserStatisticsEvents<
    TData = Awaited<
        ReturnType<typeof getRequestShouldSendUserStatisticsEvents>
    >,
    TError = ErrorType<HTTPValidationErrorDTO>,
>(
    params: GetRequestShouldSendUserStatisticsEventsParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<typeof getRequestShouldSendUserStatisticsEvents>
                >,
                TError,
                TData
            >
        >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
} {
    const queryOptions =
        getGetRequestShouldSendUserStatisticsEventsQueryOptions(params, options)

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<
        TData,
        TError
    > & { queryKey: DataTag<QueryKey, TData, TError> }

    query.queryKey = queryOptions.queryKey

    return query
}
